import { useEffect } from "react";
import {chatSupportPath } from "./general-config";
const StickyChatV2 = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const widgetPath = chatSupportPath();
    const widgetUrl = widgetPath; 
    script.src =widgetUrl; 
    script.async = true;
    document.body.appendChild(script);

    // cleanup on unmount (optional but good practice)
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // no UI
};

export default StickyChatV2;
